export default function Form({ children }) {
  return <div className="auth__form">
    {children}
  </div>
}
